<template>
  <div id="app">
    <yetkidialog ref="yetkidialog"></yetkidialog>
    <loadingcomp v-bind:mesaj="' '" v-model="loadingvmodel"></loadingcomp>
    <snackbarcomp v-bind:mesaj="text1" v-model="snackbar"></snackbarcomp>
    <doviz
      ref="doviz"
      @getCurrencyList="getCurrency($event)"
      @setCurrencyValue="setCurrency($event)"
      
    ></doviz>

    <v-layout row justify-center>
      <v-dialog
        v-model="dialogAdd"
        fullscreen
        transition="dialog-bottom-transition"
        :overlay="false"
      >
        <v-card color="grey lighten-5" flat>
          <v-toolbar dark color="primary">
            <v-btn icon @click.native="dialogAdd = false" dark>
              <v-icon>close</v-icon>
            </v-btn>
            <v-toolbar-title> Fis Satir Ekle  </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
              <v-btn dark flat
                >{{ $t("Debit").toUpperCase() }} : {{ totalDept }} &nbsp;
                {{ $t("Credit").toUpperCase() }} : {{ totalCredit }} &nbsp;
                {{ $t("Balance").toUpperCase() }} : {{ totalBalance }} &nbsp;
                <span v-if="totalBalance > 0" class="red--text pr-5">
                  {{ $t("Debit").toUpperCase() }}
                </span>
                <span v-if="0 > totalBalance" class="green--text pr-5">
                  {{ $t("Credit").toUpperCase() }}
                </span>
                <span v-if="0 > totalBalance" class="red--text pr-5">
                  {{ $t("Debit").toUpperCase() }}
                </span>
              </v-btn>

              <v-btn dark flat @click="getLastValue()" class="pl-5">
                {{ $t("COPY-THE-DETAILS-OF-THE-PREVIOUS-LINE") }}
              </v-btn>

              <v-btn dark flat @click="addLine()">Kaydet</v-btn>
            </v-toolbar-items>
          </v-toolbar>

          <v-flex xs12 sm12 md12 pa-2>
            <v-card color="grey lighten-5" flat>
              <v-layout row wrap>
                <v-flex xs12 sm6 md6 pr-2>
                  <v-card class="pa-2">
                    <v-layout row wrap>
                      <v-flex xs12 sm12 md12>
                      
                        <hesapkodu
                          v-model="Accouting"
                          @setData="setValue($event)"
                        ></hesapkodu>
                      </v-flex>
                      <v-flex xs12 sm12 md4>
                        <v-autocomplete
                          :items="evrakItems"
                          item-text="Title"
                          clearable
                          item-value="Evrakkod"
                          :label="$t('Document-Type')"
                          v-model="satirParams.DocumentType"
                        ></v-autocomplete>
                      </v-flex>
                      <v-flex xs12 sm12 md8>
                        <v-text-field
                          :label="$t('Document-No')"
                          v-model="satirParams.DocumentNo"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm6 md4>
                        <tarihim
                          :etiket="$t('Maturity-Date')"
                          :detaygizle="false"
                          v-bind:defaultvalue="'ok'"
                          v-model="satirParams.ExpiryDate"
                        >
                        </tarihim>
                      </v-flex>
                      <v-flex xs12 sm12 md8>
                        <referansmerkezicomp
                          v-model="satirParams.ReferanceCode.Kod"
                          :coper="false"
                        >
                        </referansmerkezicomp>
                      </v-flex>
                      <v-flex xs12 sm12 md4>
                        <v-text-field
                          :label="$t('Sales-Invoice-No')"
                          v-model="satirParams.SalesInvoiceNo"
                        ></v-text-field>
                      </v-flex>

                      <v-flex xs12 sm12 md8>
                        <masrafmerkezicomp
                          v-model="satirParams.CostCenter.Code"
                        >
                        </masrafmerkezicomp>
                      </v-flex>
                      <v-flex xs12 sm12 md12>
                        <v-text-field
                          :label="$t('Description') + ' 1'"
                          v-model="satirParams.Explanation1"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm12 md12>
                        <v-text-field
                          :label="$t('Description') + ' 2'"
                          v-model="satirParams.Explanation2"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm12 md12>
                        <v-text-field
                          :label="$t('Description') + ' 3'"
                          v-model="satirParams.Explanation3"
                        ></v-text-field>
                      </v-flex>
                    </v-layout>
                  </v-card>
                </v-flex>

                <v-flex xs12 sm6 md6>
                  <v-card class="pa-2">
                    <v-layout row wrap>
                      <v-flex xs12 sm12 md4>
                        <v-select
                          :label="$t('Balance-Type')"
                          :items="bakiyeTipi"
                          item-text="text"
                          item-value="value"
                          v-model="satirParams.DeptCredit"
                        ></v-select>
                      </v-flex>
                      <v-flex xs12 sm12 md4>
                        <v-select
                          :label="$t('Currency')"
                          @input="getCurrencyValue()" 
                          v-model="satirParams.Currency.DovizKod"
                          :items="dovizList"
                          item-text="Title"
                          item-value="DovizKod"
                        ></v-select>
                      </v-flex>
                      <v-flex xs12 sm12 md4>
                        <v-text-field
                        @change="onChangeLinePrice"
                          :label="$t('Exchange-Rate-v2')"
                          v-model="satirParams.Rate"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm6 md4>
                        <v-text-field
                        
                          append-icon="money"
                          label="Birim Tutar"
                          v-model="satirParams.UnitPrice"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm12 md4>
                        <v-select
                          :label="$t('Unit')"
                          v-model="satirParams.Unit"
                          :items="birim"
                          item-text="text"
                          item-value="value"
                        ></v-select>
                      </v-flex>
                      <v-flex xs12 sm12 md4>
                        <v-text-field
                          :label="$t('Unit-Quantity')"
                          append-icon="money"
                          v-model="satirParams.UnitQuantities"
                        ></v-text-field>
                      </v-flex>
                      
                    
                      <v-flex xs12 sm12 md4>
                        <v-text-field
                        @change="onChangeLinePrice"
                          :label="$t('Amount')"
                          append-icon="money"
                          v-model="satirParams.LinePrice"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm12 md4>
                        <v-text-field
                        @change="onChangeCurrencyPrice"
                          :label="$t('Currency-Amount')"
                          append-icon="money"
                          v-model="satirParams.CurrencyPrice"
                        ></v-text-field>
                      </v-flex>
                     
                    </v-layout>
                  </v-card>
                </v-flex>
              </v-layout>
            </v-card>
          </v-flex>
        </v-card>
      </v-dialog>
    </v-layout>
  </div>
</template>

<script>
import yetkidialog from "@/components/app/customcomp/yetkidialog.vue";
import snackbarcomp from "@/components/app/customcomp/snackbarcomp";
import loadingcomp from "@/components/app/customcomp/loadingcomp";
import hesapkodu from "../comp/hesapkodu.vue";
import referansmerkezicomp from "@/components/app/bilet/partpage/referanscomp.vue";
import masrafmerkezicomp from "@/components/app/bilet/partpage/masrafmerkezicomp.vue";
import tarihim from "@/components/app/customcomp/tarihim.vue";
import auth from "@/api/auth";
import doviz from "../comp/doviz.vue";

export default {
  props: {
    satirID: {},
  },
  data() {
    return {
      addDefaultCurrency:null,
      Accouting: null,
      dialogAdd: false,
      satirParams: {
        UserID: 0,
        RecieptLineID: 0,
        RecieptID: 0,
        LineNumber: 0,
        AccountingCode: {
          UserID: 0,
          CodeID: 0,
          CompanyID: 0,
          MainCodeInfo: {
            CodeID: 0,
            CompanyID: 0,
            Code: null,
            CodeName: null,
          },
          Code: null,
          CodeName: null,
          AccountGroup: null,
          AccountCodeInfo: {
            SirketKodu: 0,
            Kod: null,
            Unvan: null,
            Unvani2: null,
            MuhasebeKodu: null,
            VergiDaire: null,
            VergiNo: null,
            TCNo: null,
          },
          ForeignCurrencyCode: false,
          Currency: null,
          BalanceType: 0, //0 : tüm 1: alacak 2:borç
          CodeActivePassive: false,
          ActivePassiveDate: null,
          ActivePassiveUserID: 0,
          CodeLocked: false,
          LockedDate: null,
          LockedUserID: 0,
          AlternativeCode: null,
          AlternativeCodeName: null,
          ReferanceForced: false,
          CostCenterForced: false,
          RootCode: false,
          SectionCodeForced: false,
          SavedDate: null,
          SavedUserID: 0,
          Deleted: false,
          DeletedDate: null,
          DeletedUserId: null,
          LogList: [],
        },
        DocumentType: null,
        DocumentNo: null,
        Explanation1: null,
        Explanation2: null,
        Explanation3: null,
        DeptCredit: false,
        LinePrice: 0.0,
        Rate: 0.0,
        Currency: {
          DovizKod: null,
          DovizAdi: null,
          DovizUnvan: null,
          EkranNo: 0,
          Title: null,
        },
        CurrencyPrice: 0.0,
        Unit: null,
        UnitQuantities: 0.0,
        UnitPrice: 0.0,
        ReferanceCode: {
          SirketKodu: 0,
          Kod: null,
          ReferansAd: null,
          KayitTarihi: null,
          KapanisTarihi: null,
          Tip: null,
          Title: null,
        },
        CostCenter: {
          CompanyCode: 0,
          Code: null,
          CodeName: null,
          Tip: 0,
          KrediLimit: 0.0,
          Title: null,
          AltMasraf: null,
          LogoSirket: null,
          LogoBolum: null,
        },
        SalesInvoiceNo: null,
        ExpiryDate: null,
        SavedDate: null,
        SavedUserID: 0,
        Deleted: false,
        DeletedDate: null,
        DeletedUserId: 0,
      },
      text1: null,
      snackbar: false,
      yetkidialog: false,
      loadingvmodel: false,
      sayfayetki: {
        Screen: false,
        Update: false,
        Save: false,
        Delete: false,
        Status: false,
        Message: null,
        islem: 0,
      },
      evrakItems: [],
      dovizList: [],
      birim: [
        {
          text: "adet",
          value: "adet",
        },
        {
          text: "kilo",
          value: "kilo",
        },
        {
          text: this.$t("gram"),
          value: "gram",
        },
        {
          text: this.$t("meter"),
          value: "metre",
        },
        {
          text: "Cm",
          value: "Cm",
        },
      ],
      bakiyeTipi: [
        {
          text: this.$t("Debit"),
          value: false,
        },
        {
          text: this.$t("Credit"),
          value: true,
        },
      ],
      credentials: JSON.parse(window.localStorage.getItem("credentials")),
      totalDept: 0,
      totalCredit: 0,
      totalBalance: 0,
      RecieptDate:null
    };
  },
  methods: {
    getDefaultCurrency(){

      var SirketParametre=null;
      var params = {
          SirketKodu: this.credentials.SirketKodu
        }
        this.$http.post(auth.API_URL + 'api/Parameters/CompanyGet', params, {
          headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
          }
        }).then((response) => {
                  this.loadingvmodel=false

          SirketParametre = response.body

          this.addDefaultCurrency=SirketParametre.DefaultCurrency;
       
        }, (response) => {
                  this.loadingvmodel=false

          if (response.status === 0) {
            this.text = 'Service Unavailable'
            this.snackbar = true

          } else {
            this.text = 'Service Unavailable'
            this.snackbar = true
          }
        })
    },
    onChangeLinePrice () {
      if (parseFloat(this.satirParams.Rate)==0)
      {
        this.satirParams.CurrencyPrice=0;
        return;
      }
     
     
      var lineprice=this.satirParams.LinePrice.toString().replace(',', '');
      var rate=this.satirParams.Rate.toString().replace(',', '');
      let result = parseFloat(lineprice) / parseFloat(rate) ;
     
        this.satirParams.CurrencyPrice = result
          .toFixed(2)
          .replace(/(\d)(?=(\d{3})+\.)/g, "$1,");
      if (this.satirParams.CurrencyPrice == 0) {
        
      } else if (this.satirParams.LinePrice == 0) {
        
        let result = this.satirParams.CurrencyPrice * this.satirParams.Rate;
        this.satirParams.LinePrice = result
          .toFixed(2)
          .replace(/(\d)(?=(\d{3})+\.)/g, "$1,");
      }
      
    },
    onChangeCurrencyPrice () {
      
      let result = this.satirParams.CurrencyPrice * this.satirParams.Rate;
        this.satirParams.LinePrice = result
          .toFixed(2)
          .replace(/(\d)(?=(\d{3})+\.)/g, "$1,");
     
    },
    setLastValue(val) {

      val.RecieptLineID = 0;
      this.satirParams = val;
      this.satirParams.RecieptLineID = 0;
      var accoutingData = {
        BalanceType: val.AccountingCode.BalanceType,
        Code: val.AccountingCode.Code,
        CodeID: val.AccountingCode.CodeID,
        CodeName: val.AccountingCode.CodeName,
        CompanyID: val.AccountingCode.CompanyID,
      };

      this.Accouting = accoutingData;
    },
    setValue(val) {

      var accoutingData = {
        BalanceType: val.BalanceType,
        Code: val.Code,
        CodeID: val.CodeID,
        CodeName: val.CodeName,
        CompanyID: val.CompanyID,
      };

      this.Accouting = accoutingData;
    },
    getLastValue() {
      this.$emit("getLastValue");
    },
    updateDialog(val) {
      this.loadingvmodel = true;
      this.dialogAdd = true;
      let params = {
        UserID: this.credentials.UserID,
        RecieptID: val.RecieptID,
        RecieptLineID: val.RecieptLineID,
        FirstDate: null,
        LastDate: null,
      };
      this.$http
        .post(auth.API_URL + "api/AccountingReciepts/RecieptLineLoad", params, {
          headers: {
            Authorization: "Bearer " + auth.getAuthHeader(),
          },
        })
        .then(
          (response) => {
            this.loadingvmodel = false;
            this.satirParams = response.body;

            var accoutingData = {
              BalanceType: response.body.AccountingCode.BalanceType,
              Code: response.body.AccountingCode.Code,
              CodeID: response.body.AccountingCode.CodeID,
              CodeName: response.body.AccountingCode.CodeName,
              CompanyID: response.body.AccountingCode.CompanyID,
            };
            this.Accouting = accoutingData;
          },
          (response) => {
            if (response.status === 0) {
              this.text1 = "Service Unavailable-RecieptLineLoad";
              this.snackbar = true;
              this.loadingvmodel = false;
            } else {
              this.text1 = "Service Unavailable-RecieptLineLoad";
              this.snackbar = true;
              this.loadingvmodel = false;
            }
          }
        );
    },
    addLine() {
      this.satirParams.AccountingCode.CodeID = this.Accouting.CodeID;
      this.satirParams.AccountingCode.CompanyID = this.Accouting.CompanyID;
      this.satirParams.AccountingCode.Code = this.Accouting.Code;
      this.satirParams.AccountingCode.CodeName = this.Accouting.CodeName;
      this.satirParams.UserID = this.credentials.UserID;
      this.satirParams.RecieptID = this.satirID;
      this.loadingvmodel = true;
      this.$http
        .post(
          auth.API_URL + "api/AccountingReciepts/RecieptLineSave",
          this.satirParams,
          {
            headers: {
              Authorization: "Bearer " + auth.getAuthHeader(),
            },
          }
        )
        .then(
          (response) => {
            if (response.body.Status) {
              this.loadingvmodel = false;
              //this.dialogAdd = false;
              this.$emit("loadFisAndContinue", this.satirID);
            } else {
               this.text1 = this.$t(response.body.ResponseMessage);
              this.snackbar = true;
              this.loadingvmodel = false;
            }
          },
          (response) => {
            if (response.status === 0) {
              this.text1 = "Service Unavailable-RecieptLineSave";
              this.snackbar = true;
              this.loadingvmodel = false;
            } else {
              this.text1 = "Service Unavailable-RecieptLineSave";
              this.snackbar = true;
              this.loadingvmodel = false;
            }
          }
        );
      // this.dialogAdd = false;
    },
    dialogAddContinue(val) {
      this.RecieptDate=val.RecieptDate;
      this.totalDept = val.TotalDept;
      this.totalCredit = val.TotalCredit;
      this.totalBalance = val.TotalBalance;
      this.dialogAdd = true;
      var newSatir = {
        UserID: 0,
        RecieptLineID: 0,
        RecieptID: 0,
        LineNumber: 0,
        AccountingCode: {
          UserID: 0,
          CodeID: 0,
          CompanyID: 0,
          MainCodeInfo: {
            CodeID: 0,
            CompanyID: 0,
            Code: null,
            CodeName: null,
          },
          Code: null,
          CodeName: null,
          AccountGroup: null,
          AccountCodeInfo: {
            SirketKodu: 0,
            Kod: null,
            Unvan: null,
            Unvani2: null,
            MuhasebeKodu: null,
            VergiDaire: null,
            VergiNo: null,
            TCNo: null,
          },
          ForeignCurrencyCode: false,
          Currency: null,
          BalanceType: 0, //0 : tüm 1: alacak 2:borç
          CodeActivePassive: false,
          ActivePassiveDate: null,
          ActivePassiveUserID: 0,
          CodeLocked: false,
          LockedDate: null,
          LockedUserID: 0,
          AlternativeCode: null,
          AlternativeCodeName: null,
          ReferanceForced: false,
          CostCenterForced: false,
          RootCode: false,
          SectionCodeForced: false,
          SavedDate: null,
          SavedUserID: 0,
          Deleted: false,
          DeletedDate: null,
          DeletedUserId: null,
          LogList: [],
        },
        DocumentType: null,
        DocumentNo: null,
        Explanation1: null,
        Explanation2: null,
        Explanation3: null,
        DeptCredit: false,
        LinePrice: 0.0,
        Rate: 0.0,
        Currency: {
          DovizKod: null,
          DovizAdi: null,
          DovizUnvan: null,
          EkranNo: 0,
          Title: null,
        },
        CurrencyPrice: 0.0,
        Unit: null,
        UnitQuantities: 0.0,
        UnitPrice: 0.0,
        ReferanceCode: {
          SirketKodu: 0,
          Kod: null,
          ReferansAd: null,
          KayitTarihi: null,
          KapanisTarihi: null,
          Tip: null,
          Title: null,
        },
        CostCenter: {
          CompanyCode: 0,
          Code: null,
          CodeName: null,
          Tip: 0,
          KrediLimit: 0.0,
          Title: null,
          AltMasraf: null,
          LogoSirket: null,
          LogoBolum: null,
        },
        SalesInvoiceNo: null,
        ExpiryDate: null,
        SavedDate: null,
        SavedUserID: 0,
        Deleted: false,
        DeletedDate: null,
        DeletedUserId: 0,
      };
      this.satirParams = newSatir;

      this.Accouting = null;
    },
    dialogOpen(val) {

      
      
      
      this.RecieptDate=val.RecieptDate;
      this.totalDept = val.TotalDept;
      this.totalCredit = val.TotalCredit;
      this.totalBalance = val.TotalBalance;
      this.dialogAdd = true;
      var newSatir = {
        UserID: 0,
        RecieptLineID: 0,
        RecieptID: 0,
        LineNumber: 0,
        AccountingCode: {
          UserID: 0,
          CodeID: 0,
          CompanyID: 0,
          MainCodeInfo: {
            CodeID: 0,
            CompanyID: 0,
            Code: null,
            CodeName: null,
          },
          Code: null,
          CodeName: null,
          AccountGroup: null,
          AccountCodeInfo: {
            SirketKodu: 0,
            Kod: null,
            Unvan: null,
            Unvani2: null,
            MuhasebeKodu: null,
            VergiDaire: null,
            VergiNo: null,
            TCNo: null,
          },
          ForeignCurrencyCode: false,
          Currency: null,
          BalanceType: 0, //0 : tüm 1: alacak 2:borç
          CodeActivePassive: false,
          ActivePassiveDate: null,
          ActivePassiveUserID: 0,
          CodeLocked: false,
          LockedDate: null,
          LockedUserID: 0,
          AlternativeCode: null,
          AlternativeCodeName: null,
          ReferanceForced: false,
          CostCenterForced: false,
          RootCode: false,
          SectionCodeForced: false,
          SavedDate: null,
          SavedUserID: 0,
          Deleted: false,
          DeletedDate: null,
          DeletedUserId: null,
          LogList: [],
        },
        DocumentType: null,
        DocumentNo: null,
        Explanation1: null,
        Explanation2: null,
        Explanation3: null,
        DeptCredit: false,
        LinePrice: 0.0,
        Rate: 1,
        Currency: {
          DovizKod: null,
          DovizAdi: null,
          DovizUnvan: null,
          EkranNo: 0,
          Title: null,
        },
        CurrencyPrice: 0.0,
        Unit: null,
        UnitQuantities: 0.0,
        UnitPrice: 0.0,
        ReferanceCode: {
          SirketKodu: 0,
          Kod: null,
          ReferansAd: null,
          KayitTarihi: null,
          KapanisTarihi: null,
          Tip: null,
          Title: null,
        },
        CostCenter: {
          CompanyCode: 0,
          Code: null,
          CodeName: null,
          Tip: 0,
          KrediLimit: 0.0,
          Title: null,
          AltMasraf: null,
          LogoSirket: null,
          LogoBolum: null,
        },
        SalesInvoiceNo: null,
        ExpiryDate: null,
        SavedDate: null,
        SavedUserID: 0,
        Deleted: false,
        DeletedDate: null,
        DeletedUserId: 0,
      };
      this.satirParams = newSatir;
    

      this.Accouting = null;
    },
    setCurrency(val) {
      
      if (val != 0) {
        this.satirParams.Rate = val;
      } else {
        this.satirParams.Rate = 1;
      }
    },
    getCurrencyValue() {
      console.log(this.satirParams.Currency.DovizKod);
      this.$refs.doviz.getCurrencyValuewithdate(this.satirParams.Currency.DovizKod,this.RecieptDate);
      

    },
    getCurrency(val) {
      this.dovizList = val;
    },
    getEvrakTipi() {
      var credentials = JSON.parse(window.localStorage.getItem("credentials"));

      let params = {
        CompanyCode: credentials.SirketKodu,
      };
      this.$http
        .post(auth.API_URL + "api/doctype/List", params, {
          headers: {
            Authorization: "Bearer " + auth.getAuthHeader(),
          },
        })
        .then(
          (response) => {
            this.evrakItems = response.body;
          },
          (response) => {
            if (response.status === 0) {
              this.text1 = "Service Unavailable-Evrak Tipi";
              this.snackbar = true;
            } else {
              this.text1 = "Service Unavailable-Evrak Tipi";
              this.snackbar = true;
            }
          }
        );
    },
  },
  watch: {
    
    // "satirParams.Rate": function (val) {
    //   if (this.satirParams.CurrencyPrice == 0) {
    //     let result = this.satirParams.Rate * this.satirParams.LinePrice;
    //     this.satirParams.CurrencyPrice = result
    //       .toFixed(2)
    //       .replace(/(\d)(?=(\d{3})+\.)/g, "$1,");
    //   } else if (this.satirParams.LinePrice == 0) {
    //     let result = this.satirParams.CurrencyPrice / this.satirParams.Rate;
    //     this.satirParams.LinePrice = result
    //       .toFixed(2)
    //       .replace(/(\d)(?=(\d{3})+\.)/g, "$1,");
    //   }
    // },
  },
  components: {
    yetkidialog,
    snackbarcomp,
    loadingcomp,
    hesapkodu,
    referansmerkezicomp,
    masrafmerkezicomp,
    tarihim,
    doviz,
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.prevRoute = from.path;
    });
  },
 
  mounted() {
    
    this.getEvrakTipi();
    this.$refs.doviz.getCurrencyList();
    // this.sayfayetki = helpers.pageScreenAuth(this.$route.name);
    // if (this.sayfayetki.Status == true) {
    //   //YETKİ OK
    // } else {
    //   this.$refs.yetkidialog
    //     .open(this.sayfayetki.Message, this.sayfayetki.islem)
    //     .then((sonuc) => {
    //       if (sonuc == true) {
    //         if (this.prevRoute != null) {
    //           var url = "#" + this.prevRoute;
    //           window.open(url, "_self");
    //         } else {
    //           var urlMain = "#/";
    //           window.open(urlMain, "_self");
    //         }
    //       }
    //     });
    // }
  },
};
</script>

<style>
</style>

